import { isEmpty } from '@dxb-web-ui-framework/common/utils/Helper';
import { BeneficiariesResponseDTO, Beneficiary, BeneficiaryDTO } from '../entities';
import { BeneficiaryList } from '../entities';

const beneficiariesResponseDTOToBeneficiariesAdapter = (data: BeneficiariesResponseDTO): BeneficiaryList => {
  if (!data.body) {
    throw new Error('Error');
  }

  const { beneficiaries, totalResults } = data.body;


  return {
    beneficiaries: (beneficiaries as BeneficiaryDTO[]).map(
      beneficiary =>
        new Beneficiary(
          beneficiary.id,
          beneficiary.name,
          beneficiary.data.iban,
          beneficiary.data.bankName,
          beneficiary.data.bic,
          beneficiary.data.creditorFullName,
          beneficiary.data.bankCountry,
          beneficiary.data.bankCity,
          beneficiary.data.bankAddress,
          beneficiary.data.debitCurrency,
          beneficiary.data.debitCurrDescription,
          beneficiary.data.ecommbx,
          beneficiary.data?.beneficiaryCity,
          beneficiary.data?.beneficiaryAddress,
          beneficiary.data?.beneficiaryCountry,
        ),
    ),
    totalResults,
  };
};

export { beneficiariesResponseDTOToBeneficiariesAdapter };
